import { observer } from 'mobx-react';
import React, { useCallback, useState } from 'react';
import Map from 'react-map-gl';
import { useMapState } from '../../hooks/useMapState';
import DrawControl from './DrawControl';
import PreviewButton, { monoStyle } from './PreviewButton';

const PropertyMapEditable = (props) => {
  const [mapStyle, setMapStyle] = useState(monoStyle);
  const boundry = props.values.boundry;
  const setValues = props.setValues;
  const formValues = props.values;
  const [[viewport, setViewport], mapRefWrapper] = useMapState(boundry);

  const onEditorUpdate = useCallback(
    (e) => {
      setValues({
        ...formValues,
        boundry: {
          type: 'FeatureCollection',
          features: e.features[0]
        }
      });
    },
    [formValues, setValues]
  );

  const onDelete = useCallback(
    (e) => {
      setValues({
        ...formValues,
        boundry: null
      });
    },
    [formValues, setValues]
  );

  return (
    <Map
      ref={mapRefWrapper}
      initialViewState={viewport}
      mapStyle={`mapbox://styles/hortplus/${mapStyle}`}
      onViewportChange={(next) => setViewport(next)}
    >
      <DrawControl
        initialBoundry={boundry}
        position='top-right'
        displayControlsDefault={false}
        controls={{
          polygon: true,
          trash: true
        }}
        defaultMode={boundry ? 'simple_select' : 'draw_polygon'}
        onCreate={onEditorUpdate}
        onUpdate={onEditorUpdate}
        onDelete={onDelete}
      />
      <PreviewButton
        setMapStyle={setMapStyle}
        mapStyle={mapStyle}
        viewport={viewport}
      />
    </Map>
  );
};

export default observer(PropertyMapEditable);
